import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Topics from './components/Topics';
import Features from './components/Features';
import Updates from './components/Updates';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Faq from './components/Faq';
import App from './components/App';
import Ranking from './components/Ranking';
import Comments from './components/Comments';
import Cards from './components/Cards';
import Media from './components/Media';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Topics />
        <Features />
        <Updates />
        <Index />
        <Carousel />
        <Faq />
        <App />
        <Ranking />
        <Comments />
        <Cards />
        <Media />
        <Contact />
      </main>
      <Footer />
    </>
  );
}